module.exports = __webpack_public_path__ + "img/preview-5.74a418f4.png";